import { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'
import { useAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import Navbar from '../components/Navbar'

export default function TaskLibrary() {
  const { profile } = useAuth()
  const [tasks, setTasks] = useState([])
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => { fetchTasks() }, [])

  async function fetchTasks() {
    const { data } = await supabase
      .from('interventions')
      .select('*')
      .eq('clinic_id', profile.clinic_id)
      .order('created_at', { ascending: false })
    setTasks(data || [])
    setLoading(false)
  }

  async function handleDelete(id) {
    if (!confirm('Delete this task?')) return
    const { count } = await supabase
      .from('intervention_assignments')
      .select('id', { count: 'exact', head: true })
      .eq('intervention_id', id)
    if (count > 0) {
      alert('This task is assigned to ' + count + ' patient' + (count !== 1 ? 's' : '') + ' and cannot be deleted. Remove it from all patient programs first.')
      return
    }
    const { error } = await supabase.from('interventions').delete().eq('id', id)
    if (!error) setTasks(prev => prev.filter(e => e.id !== id))
  }

  const filtered = tasks.filter(i => {
    const q = search.toLowerCase()
    return (
      i.title?.toLowerCase().includes(q) ||
      i.description?.toLowerCase().includes(q) ||
      i.instructions?.toLowerCase().includes(q)
    )
  })

  return (
    <>
      <Navbar />
      <div className="page">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
          <div>
            <span onClick={() => navigate('/clinician')} className="back-link" style={{ cursor: 'pointer' }}>← Dashboard</span>
            <h1>Task library</h1>
            <p>{tasks.length} task{tasks.length !== 1 ? 's' : ''}</p>
          </div>
          <button onClick={() => navigate('/clinician/interventions/new')}>+ New</button>
        </div>

        <div style={{ position: 'relative', marginBottom: '1.25rem' }}>
          <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-tertiary)', fontSize: 16, pointerEvents: 'none' }}>🔍</span>
          <input placeholder="Search tasks..." value={search} onChange={e => setSearch(e.target.value)} style={{ paddingLeft: 40 }} />
          {search && (
            <span onClick={() => setSearch('')} style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-tertiary)', cursor: 'pointer', fontSize: 18, lineHeight: 1 }}>×</span>
          )}
        </div>

        {loading && <p>Loading...</p>}

        {!loading && tasks.length === 0 && (
          <div className="empty-state">
            <div className="empty-state-icon">🩺</div>
            <h2 style={{ marginBottom: 8 }}>No tasks yet</h2>
            <p style={{ marginBottom: '1.5rem' }}>Add your first task to start building programs</p>
            <button onClick={() => navigate('/clinician/interventions/new')}>+ Add task</button>
          </div>
        )}

        {!loading && tasks.length > 0 && filtered.length === 0 && (
          <div className="empty-state">
            <div className="empty-state-icon">🔍</div>
            <h2 style={{ marginBottom: 8 }}>No results</h2>
            <p>No tasks match "{search}"</p>
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {filtered.map(task => (
            <div key={task.id} className="card" style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
              {task.media_url ? (
                <img src={task.media_url} alt={task.title} style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 10, flexShrink: 0 }} />
              ) : (
                <div style={{ width: 72, height: 72, borderRadius: 10, flexShrink: 0, background: '#f0fdf4', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28 }}>🩺</div>
              )}
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontWeight: 600, color: 'var(--text-primary)', marginBottom: 4, fontSize: 15 }}>{task.title}</p>
                {task.description && (
                  <p style={{ fontSize: 13, lineHeight: 1.5 }}>{task.description}</p>
                )}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, flexShrink: 0 }}>
                <button className="secondary" onClick={() => navigate('/clinician/interventions/' + task.id + '/edit')} style={{ fontSize: 12, padding: '6px 12px' }}>Edit</button>
                <button className="danger" onClick={() => handleDelete(task.id)} style={{ fontSize: 12 }}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
